import SchoolsServiceClient from './SchoolsServiceClient';

export default SchoolsServiceClient;

export {
  MissingParamError,
  RequestLimitExceeded,
  UnexpectedServerResponse,
  UrlConstructionError
} from '@seneca/client-library';
export { default as BadRequestError } from './errors/BadRequestError';
export { default as ForbiddenForSchoolError } from './errors/ForbiddenForSchoolError';
export { default as SchoolInfoBySchoolIdDoesNotExistError } from './errors/SchoolInfoBySchoolIdDoesNotExistError';
export { default as SchoolInfoByUrnDoesNotExistError } from './errors/SchoolInfoByUrnDoesNotExistError';
export { default as UserSchoolInfoDoesNotExistError } from './errors/UserSchoolInfoDoesNotExistError';
export { default as BatchFetchEntitiesByExternalIdDoesNotExistError } from './errors/BatchFetchEntitiesByExternalIdDoesNotExistError';
export { default as SchoolNotFoundError } from './errors/SchoolNotFoundError';
export { default as SchoolSyncExpiredError } from './errors/SchoolSyncExpiredError';
export { default as ForbiddenAccessToSchoolEntitiesError } from './errors/ForbiddenAccessToSchoolEntitiesError';
